import {MutableRefObject} from "react";
import {css, cx} from "@panda/css";

import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {FormActions} from "@pg-mono/form";

import {getCountryId} from "../../../offer/list/helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {propertyConfiguratorSearchFormFields} from "../../../property_configurator/reducers/property_configurator_reducer";
import {Country} from "../../../region/types/Country";
import {IFetchAllSearchListsParams} from "../../actions/fetch_search_all_action";
import {searchFormFields} from "../../constants/search_form_constants";
import {SearchFormValuesType} from "../../types/SearchFormValuesType";
import {SearchTab} from "../../types/SearchTab";
import {SearchAutocomplete} from "./SearchAutocomplete";
import {SearchAutocompleteDropdown} from "./SearchAutocompleteDropdown";

interface IProps {
    onDropdownStatusChange: (isOpen: boolean) => void;
    formProps: {
        formValues: SearchFormValuesType;
        formActions: FormActions<Record<keyof typeof searchFormFields | keyof typeof propertyConfiguratorSearchFormFields, unknown>>;
        fetchAllSearchLists: (searchInput: string, params: IFetchAllSearchListsParams) => Promise<SearchTab>;
        latestQuery?: {country?: string};
    };
    onAfterChange?: (name: string, value: unknown) => void;
    onSearchSubmit: () => void;
    onAfterTabSwitch: () => void;
    onInputMount: (ref: MutableRefObject<HTMLInputElement | null>) => void;
    isInModal?: boolean;
    showSelectedUnderInput?: boolean;
    onInputClick?: () => void;
    inputDisabled?: boolean;
    includeDistanceFilter?: boolean;
    placeholder?: string;
    showArrowOnMobile?: boolean;
    disableMultiRegion?: boolean;
    isDropdownOpen?: boolean;
    hideRecentFilters?: boolean;
}

export const SearchAutocompleteWithDropdown = (props: IProps) => {
    const {
        onDropdownStatusChange,
        formProps,
        onAfterChange,
        onSearchSubmit,
        onAfterTabSwitch,
        onInputMount,
        isInModal,
        showSelectedUnderInput,
        onInputClick,
        inputDisabled,
        includeDistanceFilter = true,
        placeholder = "Gdzie chcesz mieszkać",
        showArrowOnMobile,
        disableMultiRegion,
        isDropdownOpen,
        hideRecentFilters
    } = props;

    const searchCountry = getCountryId(props.formProps.latestQuery?.country) || Country.POLAND;

    return (
        <div className={cx(searchAutocompleteWrapper, showSelectedUnderInput && css({w: "100%"}))}>
            <SearchAutocomplete
                values={formProps.formValues}
                onChange={formProps.formActions.update}
                onAfterChange={onAfterChange}
                onSubmit={onSearchSubmit}
                onDropdownStatusChange={onDropdownStatusChange}
                onAfterTabSwitch={onAfterTabSwitch}
                inputIcon={<MapMarkerOutlineIcon size="2.4" />}
                placeholder={placeholder}
                fetchAllSearchLists={(input, params) => formProps.fetchAllSearchLists(input, {...params, country: searchCountry})}
                isInModal={isInModal}
                showSelectedUnderInput={showSelectedUnderInput}
                onInputMount={!isInModal ? onInputMount : undefined}
                includeDistanceFilter={includeDistanceFilter}
                onInputClick={onInputClick}
                inputDisabled={inputDisabled}
                showArrowOnMobile={showArrowOnMobile}
                disableMultiRegion={disableMultiRegion}
                isDropdownOpen={isDropdownOpen}
                hideRecentFilters={hideRecentFilters}
                renderDropdownList={(innerProps) => (
                    <SearchAutocompleteDropdown
                        dropdownIsOpen={innerProps.dropdownIsOpen}
                        search={innerProps.search}
                        selectedTab={innerProps.selectedTab}
                        onLinkClick={innerProps.onLinkClick}
                        requestStateObj={innerProps.requestStateObj}
                        activeItem={innerProps.activeItem}
                        offers={innerProps.offers}
                        places={innerProps.places}
                        regions={innerProps.regions}
                        removeRegionTag={innerProps.removeRegionTag}
                        vendors={innerProps.vendors}
                        getFieldProps={innerProps.getFieldProps}
                        hideRecentFilters={innerProps.hideRecentFilters}
                    />
                )}
            />
        </div>
    );
};

const searchAutocompleteWrapper = css({
    position: "relative",
    flexGrow: 1,
    flexShrink: 1,
    display: "flex",
    flexDirection: "column",

    md: {
        p: 0,
        maxHeight: "100%",
        width: "100%"
    }
});
import {MutableRefObject} from "react";
import {css, cx} from "@panda/css";

import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {FormActions} from "@pg-mono/form";

import {getCountryId} from "../../../offer/list/helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {propertyConfiguratorSearchFormFields} from "../../../property_configurator/reducers/property_configurator_reducer";
import {Country} from "../../../region/types/Country";
import {IFetchAllSearchListsParams} from "../../actions/fetch_search_all_action";
import {searchFormFields} from "../../constants/search_form_constants";
import {SearchFormValuesType} from "../../types/SearchFormValuesType";
import {SearchTab} from "../../types/SearchTab";
import {SearchAutocomplete} from "./SearchAutocomplete";
import {SearchAutocompleteDropdown} from "./SearchAutocompleteDropdown";

interface IProps {
    onDropdownStatusChange: (isOpen: boolean) => void;
    formProps: {
        formValues: SearchFormValuesType;
        formActions: FormActions<Record<keyof typeof searchFormFields | keyof typeof propertyConfiguratorSearchFormFields, unknown>>;
        fetchAllSearchLists: (searchInput: string, params: IFetchAllSearchListsParams) => Promise<SearchTab>;
        latestQuery?: {country?: string};
    };
    onAfterChange?: (name: string, value: unknown) => void;
    onSearchSubmit: () => void;
    onAfterTabSwitch: () => void;
    onInputMount: (ref: MutableRefObject<HTMLInputElement | null>) => void;
    isInModal?: boolean;
    showSelectedUnderInput?: boolean;
    onInputClick?: () => void;
    inputDisabled?: boolean;
    includeDistanceFilter?: boolean;
    placeholder?: string;
    showArrowOnMobile?: boolean;
    disableMultiRegion?: boolean;
    isDropdownOpen?: boolean;
    hideRecentFilters?: boolean;
}

export const SearchAutocompleteWithDropdown = (props: IProps) => {
    const {
        onDropdownStatusChange,
        formProps,
        onAfterChange,
        onSearchSubmit,
        onAfterTabSwitch,
        onInputMount,
        isInModal,
        showSelectedUnderInput,
        onInputClick,
        inputDisabled,
        includeDistanceFilter = true,
        placeholder = "Gdzie chcesz mieszkać",
        showArrowOnMobile,
        disableMultiRegion,
        isDropdownOpen,
        hideRecentFilters
    } = props;

    const searchCountry = getCountryId(props.formProps.latestQuery?.country) || Country.POLAND;

    return (
        <div className={cx(searchAutocompleteWrapper, showSelectedUnderInput && css({w: "100%"}))}>
            <SearchAutocomplete
                values={formProps.formValues}
                onChange={formProps.formActions.update}
                onAfterChange={onAfterChange}
                onSubmit={onSearchSubmit}
                onDropdownStatusChange={onDropdownStatusChange}
                onAfterTabSwitch={onAfterTabSwitch}
                inputIcon={<MapMarkerOutlineIcon size="2.4" />}
                placeholder={placeholder}
                fetchAllSearchLists={(input, params) => formProps.fetchAllSearchLists(input, {...params, country: searchCountry})}
                isInModal={isInModal}
                showSelectedUnderInput={showSelectedUnderInput}
                onInputMount={!isInModal ? onInputMount : undefined}
                includeDistanceFilter={includeDistanceFilter}
                onInputClick={onInputClick}
                inputDisabled={inputDisabled}
                showArrowOnMobile={showArrowOnMobile}
                disableMultiRegion={disableMultiRegion}
                isDropdownOpen={isDropdownOpen}
                hideRecentFilters={hideRecentFilters}
                renderDropdownList={(innerProps) => (
                    <SearchAutocompleteDropdown
                        dropdownIsOpen={innerProps.dropdownIsOpen}
                        search={innerProps.search}
                        selectedTab={innerProps.selectedTab}
                        onLinkClick={innerProps.onLinkClick}
                        requestStateObj={innerProps.requestStateObj}
                        activeItem={innerProps.activeItem}
                        offers={innerProps.offers}
                        places={innerProps.places}
                        regions={innerProps.regions}
                        removeRegionTag={innerProps.removeRegionTag}
                        vendors={innerProps.vendors}
                        getFieldProps={innerProps.getFieldProps}
                        hideRecentFilters={innerProps.hideRecentFilters}
                    />
                )}
            />
        </div>
    );
};

const searchAutocompleteWrapper = css({
    position: "relative",
    flexGrow: 1,
    flexShrink: 1,
    display: "flex",
    flexDirection: "column",

    md: {
        p: 0,
        maxHeight: "100%",
        width: "100%"
    }
});
